import { z } from 'zod';

import { MessageAuthorSchema } from './message_author';
import { MessageIdSchema } from './message_envelope';

export const ConversationToolCallSchema = z.object({
  tool: z.string(),
  durationMs: z.number(),
  error: z.string().nullable(),
});

export const ConversationTurnSchema = z.object({
  // Who authored the turn (canonical platform vocabulary, see
  // `MessageAuthorSchema`): `customer` / `agent` / `operator` / `system`.
  // `system` marks a turn that isn't a conversational exchange — e.g. a
  // proactive dispatch (disparo ativo) the business sent before the
  // customer engaged.
  author: MessageAuthorSchema,
  text: z.string(),
  at: z.coerce.date(),
  agent: z.string().optional(),
  toolCalls: z.array(ConversationToolCallSchema).optional(),
  durationMs: z.number().optional(),
});

export const ConversationThreadSchema = z.object({
  threadId: z.string().min(1),
  turns: z.array(ConversationTurnSchema),
});

/**
 * Corpo do endpoint interno do conversation (POST /internal/conversations/
 * :id/outbound), usado para entregar uma resposta do operador.
 * `messageId` é a chave de idempotência.
 */
export const ConversationOutboundOperatorRequestSchema = z.object({
  text: z.string().min(1),
  messageId: MessageIdSchema,
});

export type ConversationToolCall = z.infer<typeof ConversationToolCallSchema>;
export type ConversationTurn = z.infer<typeof ConversationTurnSchema>;
export type ConversationThread = z.infer<typeof ConversationThreadSchema>;
export type ConversationOutboundOperatorRequest = z.infer<
  typeof ConversationOutboundOperatorRequestSchema
>;
